export default __webpack_public_path__ + "static/media/reset_pass_done.6de97565.png";